import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },

  {
    path: "/aboutUs",
    name: "aboutUs",
    component: () => import("@/views/aboutUs.vue"),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/ContactView",
    name: "ContactView",
    component: () => import("@/views/ContactView.vue"),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/goodsList",
    name: "goodsList",
    component: () => import("@/views/goodsList.vue"),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/NewsList",
    name: "NewsList",
    component: () => import("@/views/NewsList.vue"),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/NewDetail",
    name: "NewDetail",
    component: () => import("@/views/NewDetail.vue"),
    meta: {
      keepAlive: true,
      useCustomSEO: true,
    },
  },
  {
    path: "/goodsDetail",
    name: "goodsDetail",
    component: () => import("@/views/goodsDetail.vue"),
    meta: {
      keepAlive: true,
      useCustomSEO: true,
    },
  },
  {
    path: "/introduce",
    name: "introduce",
    component: () => import("@/views/introduce.vue"),
    meta: {
      keepAlive: true,
      useCustomSEO: true,
    },
  },
  {
    path: "/technology",
    name: "technology",
    component: () => import("@/views/technology.vue"),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/service",
    name: "service",
    component: () => import("@/views/service.vue"),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/case",
    name: "case",
    component: () => import("@/views/case.vue"),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/problem",
    name: "problem",
    component: () => import("@/views/problem.vue"),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: "/search",
    name: "search",
    component: () => import("@/views/search.vue"),
    meta: {
      keepAlive: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果是通过浏览器前进/后退按钮触发的导航，则恢复之前的位置
    if (savedPosition) {
      return savedPosition;
    } else {
      // 否则，始终滚动到顶部
      return { x: 0, y: 0 };
    }
  },
});
// 在路由导航守卫中临时隐藏滚动条
router.beforeEach((to, from, next) => {
  document.body.style.overflow = "hidden"; // 隐藏滚动条
  next();
});

router.afterEach(() => {
  document.body.style.overflow = ""; // 恢复滚动条
  window.scrollTo(0, 0); // 强制回到顶部
  
});
export default router;
